import React, { useEffect, useState } from "react";
import { VeneersForm, VeneersProps } from "../../../types/UploadFieldsType";
import TextInput from "../formComp/TextInputOld";
import SelectInput from "../formComp/SelectInputOld";
import ToothSelector from "../formComp/ToothSelectorOld";

const Veneers: React.FC<VeneersProps> = ({ onChange }) => {
  const [form, setForm] = useState<VeneersForm>({
    toothNumbers: [],
    photoIncluded: "",
    preparation: "",
    mergedModelNeeded: "",
    placementTag: "",
    changeInVerticalDimention: "",
    otherConsiderations: "",
  });

  const handleToothClick = (type: "toothNumbers", tooth: number) => {
    const toothStr = tooth.toString();

    setForm((prev) => {
      const updated = prev[type].includes(toothStr)
        ? prev[type].filter((t) => t !== toothStr)
        : [...prev[type], toothStr];
      return { ...prev, [type]: updated };
    });
  };

  const handleChange = (field: keyof VeneersForm, value: string) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    onChange(form);
  }, [form, onChange]);

  return (
    <div className="w-full text-sm md:text-lg text-gray-900">
      <h2 className="font-bold mb-4 border-b-2 border-[#2fa9bf]">
        VEENERS
      </h2>

      <div className="w-[100%] md:w-[90%]">
        {/* Tooth Selection */}
        <div className="mb-2 flex">
          <label className="block mb-1 w-[35%]">
            Tooth #s<span className="text-red-500">*</span>
          </label>
          <div className="w-[65%]">
            <ToothSelector
              toothNumbers={form.toothNumbers}
              onToothClick={(tooth) => handleToothClick("toothNumbers", tooth)}
            />
          </div>
        </div>

        {/* Photo Included */}
        <SelectInput
          label="Photo Included"
          name="photoIncluded"
          value={form.photoIncluded}
          onChange={(e) => handleChange("photoIncluded", e.target.value)}
          options={[
            { value: "Yes", label: "Yes" },
            { value: "No", label: "No" },
          ]}
        />

        {/* Preparation */}
        <SelectInput
          label="Preparation"
          name="preparation"
          value={form.preparation}
          onChange={(e) => handleChange("preparation", e.target.value)}
          options={[
            { value: "No preparation", label: "No preparation" },
            { value: "Minimal preparation", label: "Minimal preparation" },
          ]}
        />

        {/* Merged model */}
        <SelectInput
          label="Merged model needed"
          name="mergedModelNeeded"
          value={form.mergedModelNeeded}
          onChange={(e) => handleChange("mergedModelNeeded", e.target.value)}
          options={[
            { value: "Yes", label: "Yes" },
            { value: "No", label: "No" },
          ]}
        />

        {/* Placemant tag */}
        <SelectInput
          label="Placement tag"
          name="placementTag"
          value={form.placementTag}
          onChange={(e) => handleChange("placementTag", e.target.value)}
          options={[
            { value: "Yes", label: "Yes" },
            { value: "No", label: "No" },
          ]}
        />

        {/* Change in vertial dimention */}
        <TextInput
          optional
          label="Change in vertical dimention (in mm)"
          name="changeInVerticalDimention"
          value={form.changeInVerticalDimention}
          onChange={(e) =>
            handleChange("changeInVerticalDimention", e.target.value)
          }
        />

        <TextInput
          optional
          label="Other Considerations"
          name="otherConsiderations"
          value={form.otherConsiderations}
          onChange={(e) => handleChange("otherConsiderations", e.target.value)}
        />
      </div>
    </div>
  );
};

export default Veneers;
